// Declare window.config to fix TypeScript error
declare global {
	interface Window {
		config: {
			API_URL?: string;
			VITE_API_URL?: string;
		};
	}
}

export const apiUrl = new URL(import.meta.env.VITE_API_URL);
